{
    "name": "Ornamental Gourds",
    "binomial_name": "",
    "common_names": [],
    "description": "",
    "sun_requirements": "",
    "sowing_method": "",
    "spread": 0,
    "row_spacing": 0,
    "height": 0,
    "growing_degree_days": 0,
    "companions": [],
    "image": "/crops/images/ornamental-gourd.jpg",
    "icon": "/crops/icons/ornamental-gourd.avif"
}